import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Home from "./Home";
import Features from "./Features";
import Questions from "./Questions";
import Contact from "./Contact";
import Footer from "./Footer";
import Testimonials from "./Testimonials";
import DesktopApp from "./Desktop";
import ExamCamera from "./ExamCamera";

import { useLocation } from "react-router-dom";
import PromoVideoSection from "./PromoVideo";
import ExamTerminalWrapper from "./ExamTerminalWrapper";
import useExamStores from "../../stores/useExamStores";

const MainPage = () => {
  const examContext = useExamStores();
  const location = useLocation();
  useEffect(() => {
    if (["/", "/test/finalresult"].includes(location.pathname)) {
      examContext.setFaceVerified(false);
    }
  }, [location.pathname]);
  return (
    <>
      <Navbar />
      <section id="home">
        <Home />
      </section>
      <section id="promovideo">
        <PromoVideoSection />
      </section>
      <section id="examterminal">
        <ExamTerminalWrapper />
      </section>
      <section id="features">
        <Features />
      </section>
      <ExamCamera />
      <section id="questions">
        <Questions />
      </section>
      <section id="desktopapp">
        <DesktopApp />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <Footer />
    </>
  );
};

export default MainPage;
